import React from 'react';
import HeaderMobile from './HeaderMobile';

const HeroSectionMobile = ({ headline, subheadline, buttonText, initialTransparent }) => {
  return (
    <div
      className="hero-section-mobile"
      style={{
        position: 'relative',
        height: '100vh',
        minHeight: '600px', // Mínima altura para asegurar visibilidad en móvil
        backgroundImage: 'url(https://api.mundozapatos.org/images/images/fondo_movil.jpg)', // Imagen específica para móvil
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <HeaderMobile initialTransparent={initialTransparent} />
      <div
        className="full-screen-content"
        style={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', // Centrar texto vertical y horizontalmente
          textAlign: 'center', // Alinear el texto en el centro
        }}
      >
        <div
          style={{
            color: '#fff',
            fontWeight: 'bold',
          }}
        >
          {subheadline && <p style={{ fontSize: '14px', margin: 0 }}>{subheadline}</p>}
          {headline && <p style={{ fontSize: '28px', margin: '10px 0' }}>{headline}</p>}
          {buttonText && (
            <button
              style={{
                border: '1px solid white',
                color: 'white',
                backgroundColor: 'transparent',
                padding: '10px 20px',
                cursor: 'pointer',
                fontSize: '16px',
                transition: 'background-color 0.3s ease, color 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.color = 'black';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = 'white';
              }}
            >
              {buttonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSectionMobile;
